import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics';
import {
  Button,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  RadioGroup,
} from 'components';
import { CircleAlert } from 'lucide-react';

export const VaccinationDialogContent = styled(DialogContent).attrs({
  className: 'sm:max-w-[420px] gap-4 rounded-sm p-4',
})``;

export const VaccinationDialogHeader = styled(DialogHeader).attrs({
  className: 'gap-2 text-left',
})``;

export const VaccinationDialogTitle = styled(DialogTitle).attrs({
  className: 'text-base',
})``;

export const PatientLine = styled(DialogDescription).attrs<{ $visuallyHidden: boolean }>(
  ({ $visuallyHidden }) => ({
    className: `text-xs leading-4 text-muted-foreground ${MASKED_TEXT_CLASS} ${$visuallyHidden ? 'sr-only' : ''}`,
  })
)<{ $visuallyHidden: boolean }>``;

// A fieldset would not lay its legend out as a flex child, so the group is a plain div.
export const FieldGroup = styled.div.attrs({
  className: 'flex flex-col gap-2',
  role: 'group',
})``;

export const FieldLegend = styled.span.attrs({
  className: 'text-xs font-semibold leading-4',
})``;

export const OptionList = styled(RadioGroup).attrs({
  className: 'gap-2',
})``;

export const VaccineOption = styled.div.attrs({
  className: 'flex flex-col gap-2 rounded-[10px] border border-border p-2.5',
})``;

export const OptionRow = styled.div.attrs({
  className: 'flex items-center gap-2',
})``;

export const OptionLabel = styled.label.attrs({
  className: `text-sm font-medium leading-none cursor-pointer ${MASKED_TEXT_CLASS}`,
})``;

export const BatchField = styled.div.attrs({
  className: 'ml-6 flex flex-col gap-1',
})``;

export const BatchLabel = styled.label.attrs({
  className: 'text-xs font-semibold leading-4',
})``;

export const BatchInput = styled(Input).attrs({
  className: 'h-8 rounded-lg',
})``;

export const BatchHint = styled.span.attrs({
  className: 'text-xs text-muted-foreground',
})``;

export const FieldError = styled.p.attrs({
  className: 'flex items-center gap-1.5 text-xs font-medium text-destructive',
  role: 'alert',
})``;

export const FieldErrorIcon = styled(CircleAlert).attrs({
  className: 'size-3.5 shrink-0',
  'aria-hidden': true,
})``;

export const EmptyState = styled.p.attrs({
  className: 'text-sm text-muted-foreground',
})``;

export const VaccinationDialogFooter = styled(DialogFooter).attrs({
  className: 'mt-4 flex-row justify-end gap-2',
})``;

export const CancelButton = styled(Button).attrs({
  variant: 'outline',
  size: 'sm',
  className: 'border-primary text-primary',
})``;

export const SubmitButton = styled(Button).attrs({
  size: 'sm',
})``;
